// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__r8tRh","Footer__cantica":"Footer_Footer__cantica__44NE0","Footer__tg":"Footer_Footer__tg__LtcOb"};